import SubcategoryRow from "./SubcategoryRow"

export default  SubcategoryRow;
